import React, {Component} from 'react'
import {
    MDBContainer,
    MDBRow,
    MDBCol, MDBNavItem, MDBNavLink, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBBtn, MDBNav,
} from "mdbreact";
import {connect} from "react-redux";
import classes from './HomePage.module.css'
import LeftMenu from "../LeftMenu/LeftMenu";
import {Route, Switch, withRouter} from "react-router-dom";
import {Link} from "react-router-dom";
import DashBoard from "../DashBoard/DashBoard";
import CommunityPage from "../../../../Component/Community/CommmunityPage/CommunityPage";
import ListCommunity from "../../../../Component/Community/ListCommunity/ListCommunity";
import Newest from "../../../Newest/Newest";
import MySubscribedList from "../../../MySubscribedList/MySubscribedList";
import Announcement from "../../../../Announcement/Announcement";
import Hot from "../../../../Hot/Hot";
import common from "../../../../Utils/common.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import CommunityReport from "../../../../Component/Community/CommunityReport/CommunityReport";

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDisplayMiniBox: false
        }
        console.log(this.props)
    }


    componentWillUnmount() {
        window.onscroll = null;
    }

    componentDidMount() {
        window.onscroll = function () {
            if (window.pageYOffset <= 40) {
                this.setState({
                    isDisplayMiniBox: false
                })
            } else {
                this.setState({
                    isDisplayMiniBox: true
                })
            }
        }.bind(this);
    }

    render() {
        return (
            <MDBContainer className={classes.MyContainer}>
                <MDBRow className={this.state.isDisplayMiniBox ? classes.TopMenu : classes.TopMenuNormal}>
                    <MDBNav className={[classes.NavContainer, "nav-tabs"]}>

                        {
                            this.props.location.pathname.split('/')[1] === 'community' ?
                                <MDBNavItem className={classes.NavTopic}>
                                    <MDBNavLink link to="#"
                                                className={classes.NavItemActive} role="tab">
                                        社群
                                    </MDBNavLink>
                                </MDBNavItem>
                                : ''
                        }

                        <MDBNavItem className={classes.NavTopic}>
                            <MDBNavLink link to="/"
                                        className={this.props.location.pathname === '/' ? classes.NavItemActive : classes.NavItem}
                                        role="tab">
                                所有內容
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem className={classes.NavTopic}>
                            <MDBNavLink link to="/newest"
                                        className={this.props.location.pathname === '/newest' ? classes.NavItemActive : classes.NavItem}
                                        role="tab">
                                最新
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem className={classes.NavTopic}>
                            <MDBNavLink link to="/hot"
                                        className={this.props.location.pathname === '/hot' ? classes.NavItemActive : classes.NavItem}
                                        role="tab">
                                熱門
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem className={classes.NavTopic}>
                            <MDBNavLink link to="/subscribed"
                                        className={this.props.location.pathname === '/subscribed' ? classes.NavItemActive : classes.NavItem}
                                        role="tab">
                                已追蹤
                            </MDBNavLink>
                        </MDBNavItem>
                        {/*<MDBDropdown className={classes.DropDownList}>*/}
                        {/*    <MDBDropdownToggle nav caret className={classes.NavItem}>*/}
                        {/*        地區*/}
                        {/*    </MDBDropdownToggle>*/}
                        {/*    <MDBDropdownMenu>*/}
                        {/*        <MDBDropdownItem header>港島區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>中西區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>灣仔區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>東區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>南區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem divider/>*/}
                        {/*        <MDBDropdownItem header>九龍區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>深水埗區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>油尖旺區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>九龍城區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>黃大仙區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>觀塘區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem divider/>*/}
                        {/*        <MDBDropdownItem header>新界區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>葵青區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>荃灣區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>屯門區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>元朗區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>北區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>大埔區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>沙田區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>西貢區</MDBDropdownItem>*/}
                        {/*        <MDBDropdownItem>離島區</MDBDropdownItem>*/}
                        {/*    </MDBDropdownMenu>*/}
                        {/*</MDBDropdown>*/}
                        <MDBNavItem className={classes.NavTopic}>
                            <MDBNavLink link to="/announcement"
                                        className={this.props.location.pathname === '/announcement' ? classes.NavItemActive : classes.NavItem}
                                        role="tab">
                                公告
                            </MDBNavLink>
                        </MDBNavItem>

                        <MDBNavItem className={classes.NavTopic}>
                            <Link to={'/new-post'}>
                                <MDBBtn color='link' rounded className={classes.NewPostBtn}> New Post</MDBBtn>
                            </Link>
                        </MDBNavItem>

                    </MDBNav>
                </MDBRow>
                <MDBRow className={this.state.isDisplayMiniBox ? classes.BottomContent : ''}>
                    <MDBCol className={classes.MyCommunity} lg='3' xl='3'>

                        <MDBRow>
                            <MDBCol className={classes.LeftMenu}>
                                搜尋學校
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <ListCommunity/>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                    <MDBCol lg='9' xl='9'>
                        <div className={classes.MainContainer} id={'HomePageContainer'}>
                            <Switch>
                                <Route path='/' exact>
                                    <DashBoard/>
                                </Route>
                                <Route path='/newest' exact>
                                    <Newest/>
                                </Route>
                                <Route path='/subscribed' exact>
                                    <MySubscribedList/>
                                </Route>
                                <Route path='/announcement' exact>
                                    <Announcement/>
                                </Route>
                                <Route path='/hot' exact>
                                    <Hot/>
                                </Route>
                                <Route path='/community/:cid' exact>
                                    <CommunityPage/>
                                </Route>
                                <Route path='/community/:cid/report' exact>
                                    <CommunityReport/>
                                </Route>
                            </Switch>
                        </div>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>

        );
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)


export default enhance(withRouter(HomePage))